module.exports = __webpack_public_path__ + "img/weight-scale.42e68feb.svg";